export const PurchaseOrderItemsHeadOfficePage = () => {
  return <>PurchaseOrderItemsHeadOfficePage</>;
};
